import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useInView } from "react-intersection-observer"
import { useAnimation } from "framer-motion"
import { Theme } from 'theme'
import { LendingUnits } from 'components/Landing/enums'

import {
  Section,
  Item,
  Info,
  Title,
  Description,
  Image,
  Child
} from './styled'

// images
import FindImg from './assets/find.webp'
import CreateImg from './assets/create.webp'
import TournamentsImg from './assets/tournaments.webp'
import StatisticsImg from './assets/statistics.webp'

// components
import Tip from 'components/Tip'
import Buttons from 'components/Buttons'

export default function FeatureScreen() {

  const { t, i18n } = useTranslation()

  // {t("landing.footer.title")}

  return (

    <Section>

      <FeatureItem
        title={t("features.first.title")}
        description={t("features.first.description")}
        image={FindImg}
      >
        <Buttons
          onClick={() => document.querySelector('html')?.scrollTo(0, 999999)}
          variable="solid"
          height="big"
          style={{ marginTop: '3.2rem' }}
        >
          {t("btns.findTeammates")}
        </Buttons>
      </FeatureItem>
      <FeatureItem
        title={t("features.two.title")}
        description={t("features.two.description")}
        image={CreateImg}
        soon
      />
      <FeatureItem
        title={t("features.three.title")}
        description={t("features.three.description")}
        image={TournamentsImg}
        soon
      />
      <FeatureItem
        title={t("features.four.title")}
        description={t("features.four.description")}
        image={StatisticsImg}
        soon
      />

    </Section>

  )

}

interface IFeatureItem {
  title: string;
  description: string;
  image?: any;
  children?: React.ReactElement;
  soon?: boolean;
}

const FeatureItem = ({ title, soon = false, description, image, children }: IFeatureItem) => {

  const { t, i18n } = useTranslation()

  const control = useAnimation()
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: LendingUnits.animationShow
  })

  useEffect(() => {
    if (inView) {
      control.start("end");
    }
  }, [control, inView]);

  const infoAnimation = { ...Theme.motion.default, delay: 0 }

  return (
    <Item
      variants={Theme.motion.jumpBottom} initial="start" animate={control} transition={infoAnimation}
      ref={ref}
    >
      <div>
        <Info>
          <Title>{title} {soon && <Tip>{t("btns.soon")}</Tip>}</Title>
          <Description>{description}</Description>
          <Child>{children}</Child>
        </Info>
      </div>
      <Image src={image} />
    </Item>
  )

}